import { useGetDeliveryZonesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { deliveryZonesColumns, type DeliveryZoneRow } from '../constants/deliveryZonesColumns';

export const DeliveryZonesList = () => {
    const { loading, data, error } = useGetDeliveryZonesQuery();

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!data || error) {
        throw new Error('Une erreur est survenue lors de la récupération des zones de livraison');
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<DeliveryZoneRow>
                columns={deliveryZonesColumns}
                data={data.deliveryZones}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/delivery-zone/${row._id}`}
                searchPlaceholder="Nom de la zone"
            />
        </div>
    );
};
